import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Cancel, InfoOutlined, OpenInNew, ThumbDownAlt, ThumbUp, Update } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  Button,
  NumberInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { HourMinuteInput } from "../../../../Components/HourMinuteInput";
import { GetPbhCarrierType } from "../../../../Enums/PbhCarrierType";
import { GetPbhRemoveReasonSubType, UnscheduledRemoveReasonSubType } from "../../../../Enums/RemoveReasonSubType";
import { GetPbhRemoveReasonType, PbhRemoveReasonType } from "../../../../Enums/PbhRemoveReasonType";
import { UnserviceableStatu } from "../../../../Enums/UnserviceableStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { PbhRequestUnserviceablePutModel } from "../../Models/PbhRequestUnserviceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import PbhUnserviceableStatusChip from "../Statu/PbhUnserviceableStatusChip";
import { PbhUnserviceableReplenishmentType } from "../../../../../src/Constants/Constant";
import { PbhRequestFileType } from "../../../../../src/Enums/PbhRequestFileType";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";
import { OwnerType, OwnerTypeDesc } from "../../../../../src/Enums/OwnerTypes";
import { Roles } from "../../../../../src/Enums/Roles";
import { RemoveDateFromAcNonRequiredStatus } from "./Constant/Constant";
import { getTkCargoTrackingUrl } from "../../../../Helper/TkCargoHelper";
import { CarrierType } from "../../../../Enums/CarrierType";

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const UnserviceableUpdate = props => {
  const [isRejectionRecord, setIsRejectionRecord] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unserviceableFormDisabled, setUnserviceableFromDisabled] = useState(true);
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const [isFlyDubai, setIsFlyDubai] = useState<boolean>(false);
  const [isEightWing, setIsEightWing] = useState<boolean>(false);
  const [isButtonShow, setIsButtonShow] = useState(
    props.unserviceable?.status == UnserviceableStatu.Accepted ||
      props.unserviceable?.status == UnserviceableStatu.Rejected
  );
  const classes = useStyles();
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();
  const notify = useNotify();
  const history = useHistory();
  const requestId = props.requestId;
  const requestDetail = props?.requestDetail;

  useEffect(() => {
    setIsButtonShow(
      props.unserviceable?.status == UnserviceableStatu.Accepted ||
        props.unserviceable?.status == UnserviceableStatu.Rejected
    );
  }, [props.unserviceable]);

  // useEffect(() => {
  //   var flyDubai = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description;
  //   setIsFlyDubai(user?.ownerCode === flyDubai);
  //   setIsEightWing(user?.roles?.some?.(x => x == Roles.EightWings) ?? false);
  // }, [user]);

  useEffect(() => {
    dataProvider
      .getList("PbhRejectedRequestServiceables", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "DESC" },
        filter: {
          newRequestId__eq: props.requestId,
        },
      })
      .then(response => {
        if (response?.data?.length > 0) {
          setIsRejectionRecord(true);
        } else {
          setIsRejectionRecord(false);
        }
      })
      .catch(error => {
        console.error("Error fetching remarks:", error);
        setIsRejectionRecord(false);
      });
  }, [props.requestId]);

  const UpdateUnserviceable = (form, e) => {
    setLoading(true);
    let pbhRequestUnserviceableUpdateModel: PbhRequestUnserviceablePutModel = new PbhRequestUnserviceablePutModel();
    pbhRequestUnserviceableUpdateModel.Id = props.unserviceable.id;
    pbhRequestUnserviceableUpdateModel.RequestId = props.unserviceable.requestId;
    pbhRequestUnserviceableUpdateModel.Pn = e.pn;
    pbhRequestUnserviceableUpdateModel.Sn = e.sn;
    pbhRequestUnserviceableUpdateModel.Awb = e.awb;
    pbhRequestUnserviceableUpdateModel.CarrierEnum = e.carrierEnum ?? 0;
    pbhRequestUnserviceableUpdateModel.FlightNo = e.flightNo;
    pbhRequestUnserviceableUpdateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
    pbhRequestUnserviceableUpdateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
    pbhRequestUnserviceableUpdateModel.Ac = e.ac;
    pbhRequestUnserviceableUpdateModel.Batch = e.batch;
    pbhRequestUnserviceableUpdateModel.RemoveReasonType = e.removeReasonType;
    pbhRequestUnserviceableUpdateModel.RemoveReasonSubType = e.removeReasonSubType;
    pbhRequestUnserviceableUpdateModel.RemoveDateFromAc = e.removeDateFromAc === "" ? null : e.removeDateFromAc;
    pbhRequestUnserviceableUpdateModel.Tso = e.tso;
    pbhRequestUnserviceableUpdateModel.Cso = e.cso;
    pbhRequestUnserviceableUpdateModel.Dso = e.dso;
    pbhRequestUnserviceableUpdateModel.Tsr = e.tsr;
    pbhRequestUnserviceableUpdateModel.Csr = e.csr;
    pbhRequestUnserviceableUpdateModel.Dsr = e.dsr;
    pbhRequestUnserviceableUpdateModel.Tsn = e.tsn;
    pbhRequestUnserviceableUpdateModel.Csn = e.csn;
    pbhRequestUnserviceableUpdateModel.Dsn = e.dsn;
    pbhRequestUnserviceableUpdateModel.Tsi = e.tsi;
    pbhRequestUnserviceableUpdateModel.Csi = e.csi;
    pbhRequestUnserviceableUpdateModel.Dsi = e.dsi;
    pbhRequestUnserviceableUpdateModel.Status = props.unserviceable.status;
    pbhRequestUnserviceableUpdateModel.Remark = e.remark;
    pbhRequestUnserviceableUpdateModel.RemovalReasonDetail = e.removalReasonDetail;
    pbhRequestUnserviceableUpdateModel.AdSbMod = e.adSbMod;
    pbhRequestUnserviceableUpdateModel.Dom = e.dom;
    pbhRequestUnserviceableUpdateModel.Nla = e.nla;
    pbhRequestUnserviceableUpdateModel.Nha = e.nha;
    pbhRequestUnserviceableUpdateModel.EngineSerialNumber = e.engineSerialNumber;
    pbhRequestUnserviceableUpdateModel.RejectionRemark = e.rejectionRemark;
    PutUnserviceable(pbhRequestUnserviceableUpdateModel, form);
  };

  const PutUnserviceable = async (pbhRequestUnserviceablePutModel: PbhRequestUnserviceablePutModel, form) => {
    dataProvider
      .putPbhRequestUnserviceable(pbhRequestUnserviceablePutModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId + "/2");
        setIsButtonShow(true);
        setApproveButtonShown(false);
        setUnserviceableFromDisabled(true);
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          form?.restart?.(props.unserviceable);
        }, 50);
      });
  };

  const AcceptOrRejectButtonClick = (unserviceable, isApproved) => e => {
    AcceptOrRejectUnserviceable(unserviceable, isApproved);
  };

  const AcceptOrRejectUnserviceable = async (unserviceable, isApproved) => {
    let pbhRequestUnserviceableUpdateModel: PbhRequestUnserviceablePutModel;

    pbhRequestUnserviceableUpdateModel = { ...unserviceable };
    pbhRequestUnserviceableUpdateModel.Status =
      isApproved === true ? UnserviceableStatu.Accepted : UnserviceableStatu.Rejected;

    dataProvider
      .putPbhRequestUnserviceable(pbhRequestUnserviceableUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        setIsButtonShow(true);
        history.push("/pbhrequestorders/" + requestId + "/2");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const openEditableFields = e => {
    setApproveButtonShown(true);
    setUnserviceableFromDisabled(false);
  };

  const cancelUpdate = form => e => {
    form.reset();
    setApproveButtonShown(false);
    setUnserviceableFromDisabled(true);
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  const IsUpdate = values => {
    if (props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled) return false;
    if (!user?.isCustomer) return true;

    const isUnUsedStatement =
      (props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.UnusedStatement
      )?.length ?? 0) > 0;

    if (values.removeReasonType === PbhRemoveReasonType.ServiceableReturn) {
      if (!isUnUsedStatement) return false;
    }

    const isUsTagExist =
      (props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.UsTag
      )?.length ?? 0) > 0;

    //Reliability US TAG file check if FoF
    if (
      values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
    ) {
      if (!isUsTagExist) return false;
      if (values.tsi !== 0 || values.csi !== 0) return false;
    }

    //Reliability US TAG file check if Premature Failure
    if (
      values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure
    ) {
      if (!isUsTagExist) return false;
      if (values.tsi === 0 || values.tsi > 30000) return false;
    }

    return true;
  };

  const removeReasonChangeEvent = form => e => {
    form.change("removeReasonSubType", null);
    if (e.target.value === PbhRemoveReasonType.ServiceableReturn) {
      form.change("tsi", 0);
      form.change("csi", 0);
      form.change("dsi", 0);
      // form.change('removeDateFromAc', moment.utc().local())
    }
  };
  const markFormTouched = (form, values) => {
    values.carrierEnum = values.carrierEnum > 0 ? values.carrierEnum : null;
    form.initialize(values);
    // koşullu from validations çalışmıyor, onları tetiklemek için yapıldı
    form.batch(() => {
      Object.keys(values || {}).forEach(field => {
        form.registerField(field, () => {}, { touched: true });
      });
    });
  };

  return (
    <>
      <Form
        initialValues={props.unserviceable}
        onSubmit={e => {}}
        render={({ handleSubmit, form, values, invalid }) => {
          const onFormSubmit = e => {
            if (form.getState().invalid) return;
            UpdateUnserviceable(form, e);
          };
          // useEffect(() => {
          //   markFormTouched(form, values);
          // }, [isEightWing, isFlyDubai]);
          return (
            <form>
              <>
                <Grid container justifyContent="space-around" spacing={2}>
                  <Grid item xs={12} container justifyContent="space-around">
                    <SectionTitle label="Core Unit Info" />
                    <PbhUnserviceableStatusChip unserviceable={props.unserviceable} />
                  </Grid>
                  <Separator />
                  <Grid item xs={12} container justifyContent="space-around">
                    <Grid item xs={6} container direction="column" alignItems="center">
                      <Grid item xs={10}>
                        <TextInput
                          source="pn"
                          label="PN"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          defaultValue={requestDetail?.pn}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="sn"
                          label="SN"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="ac"
                          label="AC"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          defaultValue={requestDetail?.aircraft?.acReg}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <NumberInput
                          source="batch"
                          label="Batch"
                          fullWidth
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <CustomDatetime
                          fullWidth
                          source="removeDateFromAc"
                          label="Remove Date from AC"
                          variant="outlined"
                          showTime
                          maxDate={values.forwardDateToCarrier}
                          validate={[
                            ...(!RemoveDateFromAcNonRequiredStatus.includes(values.removeReasonType)
                              ? [required()]
                              : []),
                            maxValue(values.forwardDateToCarrier, "Should be before than Forward Date To Carrier"),
                          ]}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />

                        <Grid container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tso"
                              label="TSO (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="cso"
                              label="CSO (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dso"
                              label="DSO (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tsr"
                              label="TSR (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="csr"
                              label="CSR (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dsr"
                              label="DSR (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tsn"
                              label="TSN (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="csn"
                              label="CSN (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dsn"
                              label="DSN (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid item container spacing={1}>
                          {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                            values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit &&
                            (values.tsi !== 0 || values.csi !== 0) && (
                              <Chip
                                key={9999990}
                                color="primary"
                                variant="outlined"
                                label="Removal reason was selected as Unscheduled - Fail On Fit, TSI and CSI hour input must be 0."
                                icon={<InfoOutlined />}
                              />
                            )}
                        </Grid>
                        <Grid item container spacing={1}>
                          {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                            values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure &&
                            (values.tsi === 0 || values.tsi > 30000) && (
                              <Chip
                                key={9999990}
                                color="primary"
                                variant="outlined"
                                label="Removal reason was selected as Unscheduled - Premature, TSI hour cannot be 0 and must be less than 500 FH."
                                icon={<InfoOutlined />}
                              />
                            )}
                        </Grid>
                        <Grid item container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tsi"
                              label="TSI (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="csi"
                              label="CSI (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dsi"
                              label="DSI (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={props.isPageDisabled || unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <TextInput
                          source="dom"
                          label="DOM"
                          fullWidth
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="nha"
                          label="NHA"
                          fullWidth
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <SelectInput
                          source="replenishmentReason"
                          label="REPLENISHMENT REASON"
                          optionText="replenishmentTypes"
                          optionValue="value"
                          choices={PbhUnserviceableReplenishmentType}
                          fullWidth
                          resettable
                          disabled
                          defaultValue={requestDetail?.aircraft?.acReg}
                          variant="outlined"
                        />
                        <TextInput
                          source="rejectionRemark"
                          label="REJECTION REMARK"
                          fullWidth
                          resettable
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                          validate={
                            !isRejectionRecord &&
                            values.removeReasonType === PbhRemoveReasonType.RejectedQuarantinedPart
                              ? required()
                              : undefined
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6} container direction="column" alignItems="center">
                      <Grid item xs={10}>
                        {props.unserviceable?.awb && !user?.isCustomer && (
                          <a
                            href={getTkCargoTrackingUrl(props.unserviceable.awb)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#C90C0F", textDecoration: "none", fontSize: "12px" }}
                          >
                            <OpenInNew style={{ fontSize: 12, marginRight: 4 }} />
                            Track on TK Cargo
                          </a>
                        )}
                        <TextInput
                          source="awb"
                          label="AWB"
                          fullWidth
                          variant="outlined"
                          validate={isFlyDubai && isEightWing ? required() : undefined}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="flightNo"
                          label="Flight No"
                          fullWidth
                          variant="outlined"
                          validate={isFlyDubai && isEightWing ? required() : undefined}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <SelectInput
                          source="carrierEnum"
                          label="Carrier Type"
                          choices={GetPbhCarrierType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          validate={isFlyDubai && isEightWing ? required() : undefined}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <CustomDatetime
                          fullWidth
                          source="forwardDateToCarrier"
                          label="Forward Date To Carrier"
                          variant="outlined"
                          showTime
                          minDate={values.removeDateFromAc}
                          maxDate={values.estimatedDeliveryDate}
                          validate={
                            isFlyDubai && isEightWing
                              ? [
                                  required(),
                                  minValue(values.removeDateFromAc, "Should be later than Remove Date from Ac"),
                                  maxValue(values.estimatedDeliveryDate, "Should be before Forward Date to Carrier"),
                                ]
                              : [
                                  minValue(values.removeDateFromAc, "Should be later than Remove Date from Ac"),
                                  maxValue(values.estimatedDeliveryDate, "Should be before Forward Date to Carrier"),
                                ]
                          }
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <CustomDatetime
                          fullWidth
                          source="estimatedDeliveryDate"
                          label="Estimated Delivery Date"
                          variant="outlined"
                          showTime
                          minDate={values.forwardDateToCarrier}
                          validate={
                            isFlyDubai && isEightWing
                              ? [
                                  required(),
                                  minValue(values.forwardDateToCarrier, "Should be later than Forward Date to Carrier"),
                                ]
                              : [minValue(values.forwardDateToCarrier, "Should be later than Forward Date to Carrier")]
                          }
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <SelectInput
                          source="removeReasonType"
                          label="Remove Reason Type"
                          choices={GetPbhRemoveReasonType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          onChange={removeReasonChangeEvent(form)}
                          validate={required()}
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        {GetPbhRemoveReasonSubType(values.removeReasonType) && (
                          <SelectInput
                            source="removeReasonSubType"
                            label="Remove Reason Sub Type"
                            choices={GetPbhRemoveReasonSubType(values.removeReasonType)}
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            variant="outlined"
                            validate={required()}
                            disabled={props.isPageDisabled || unserviceableFormDisabled}
                          />
                        )}
                        {user?.isCustomer &&
                          values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                          (values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit ||
                            values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure) && (
                            <Chip
                              key={9999990}
                              color="primary"
                              variant="outlined"
                              label={
                                values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
                                  ? "Please Upload US TAG for Unserviceable Fail On Fit Requests!"
                                  : "Please Upload US TAG for Unserviceable Premature Failure Requests!"
                              }
                              icon={<InfoOutlined />}
                            />
                          )}
                        {user?.isCustomer && values.removeReasonType === PbhRemoveReasonType.ServiceableReturn && (
                          <Chip
                            key={9999990}
                            color="primary"
                            variant="outlined"
                            label={"You must upload Unused Statement file."}
                            icon={<InfoOutlined />}
                          />
                        )}
                        <TextInput
                          source="remark"
                          label="Remarks of Customer"
                          multiline
                          resettable
                          fullWidth
                          rows={4}
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="removalReasonDetail"
                          label="Removal Reason Detail"
                          fullWidth
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="nla"
                          label="NLA"
                          fullWidth
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="adSbMod"
                          label="AD(SB/MOD)"
                          fullWidth
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                        />
                        <TextInput
                          source="engineSerialNumber"
                          label="Engine Serial Number"
                          fullWidth
                          resettable
                          variant="outlined"
                          disabled={props.isPageDisabled || unserviceableFormDisabled}
                          defaultValue={props.unserviceable?.engineSerialNumber}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Toolbar {...props} placeholder="" classes={classes}>
                      {approveButtonShown === false &&
                        ((user?.isCustomer && props.unserviceable?.status !== UnserviceableStatu.Accepted) ||
                          !user?.isCustomer) && (
                          <>
                            <Button
                              label="Edit Core Unit"
                              disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                              size="medium"
                              variant="contained"
                              onClick={openEditableFields}
                              style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "#ffc107" }}
                            >
                              {<Update />}
                            </Button>

                            {!user?.isCustomer && (
                              <>
                                <Button
                                  label={loading ? "Core Unit is Accepted!" : "Accept Core Unit"}
                                  disabled={
                                    isButtonShow || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled
                                  }
                                  size="medium"
                                  variant="contained"
                                  onClick={AcceptOrRejectButtonClick(props.unserviceable, true)}
                                  style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "seagreen" }}
                                >
                                  {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
                                </Button>
                                <Button
                                  label={loading ? "Core Unit is Rejected!" : "Reject Core Unit"}
                                  disabled={
                                    isButtonShow || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled
                                  }
                                  size="medium"
                                  variant="contained"
                                  color="primary"
                                  onClick={AcceptOrRejectButtonClick(props.unserviceable, false)}
                                  style={{ margin: "8px" }}
                                >
                                  {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
                                </Button>
                              </>
                            )}
                          </>
                        )}

                      {approveButtonShown === true && (
                        <>
                          <Button
                            label={loading ? "Core Unit is updating!" : "Update Core Unit"}
                            disabled={loading ? true : !IsUpdate(values) || invalid}
                            size="medium"
                            variant="contained"
                            onClick={() => onFormSubmit(values)}
                            style={{
                              margin: "8px",
                              background: "#ffc107 !important",
                            }}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                          </Button>
                          <Button
                            label={loading ? "Cancel!" : "Cancel "}
                            disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={cancelUpdate(form)}
                            style={{ margin: "8px" }}
                          >
                            {<Cancel />}
                          </Button>
                        </>
                      )}
                    </Toolbar>
                  </Grid>
                </Grid>
              </>
            </form>
          );
        }}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Unserviceable} />
    </>
  );
};

const PbhRequestUnserviceableUpdate = props => {
  return (
    <UnserviceableUpdate
      unserviceable={props.unserviceable}
      requestDetail={props.requestDetail}
      requestId={props.requestId}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default PbhRequestUnserviceableUpdate;
